export enum Context {
  Listing = 1,
  B2B = 2,
  Shared = 3,
}

export const CONTEXT_LISTING = Context.Listing;
export const CONTEXT_B2B = Context.B2B;
export const CONTEXT_SHARED = Context.Shared;

export const ALL_CONTEXTS = [CONTEXT_B2B, CONTEXT_LISTING];
export const ONLY_LISTING_CONTEXTS = [CONTEXT_LISTING];
